"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var companyappApi = _interopRequireWildcard(require("@/api/companyappApi"));
var _miniProgramVersionApi = require("@/api/miniProgramVersionApi");
var _utils = require("@/utils");
var _MiniProgramReleaseManage = _interopRequireDefault(require("../components/MiniProgramReleaseManage.vue"));
var _BatchUploadDialog = _interopRequireDefault(require("../components/BatchUploadDialog.vue"));
var _BatchUploadProgress = _interopRequireDefault(require("../components/BatchUploadProgress.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var BATCH_STATUS = {
  RUNNING: {
    label: '进行中',
    type: 'warning'
  },
  SUCCESS: {
    label: '全部成功',
    type: 'success'
  },
  PARTIAL_SUCCESS: {
    label: '部分成功',
    type: 'warning'
  },
  FAILED: {
    label: '全部失败',
    type: 'danger'
  }
};
var AUDIT_STATUS = {
  CREATED: {
    label: '已创建',
    type: ''
  },
  WAITING_API: {
    label: '接口待接入',
    type: 'warning'
  },
  SUBMITTING: {
    label: '提交中',
    type: 'warning'
  },
  PENDING: {
    label: '审核中',
    type: 'warning'
  },
  DELAYED: {
    label: '审核延后',
    type: 'warning'
  },
  PASSED: {
    label: '审核通过',
    type: 'success'
  },
  REJECTED: {
    label: '审核驳回',
    type: 'danger'
  },
  WITHDRAWN: {
    label: '已撤回',
    type: 'info'
  },
  FAILED: {
    label: '提交失败',
    type: 'danger'
  }
};
var PUBLISH_STATUS = {
  CREATED: {
    label: '已创建',
    type: ''
  },
  WAITING_API: {
    label: '接口待接入',
    type: 'warning'
  },
  PUBLISHING: {
    label: '发布中',
    type: 'warning'
  },
  RELEASED: {
    label: '已发布',
    type: 'success'
  },
  FAILED: {
    label: '发布失败',
    type: 'danger'
  },
  NOT_RELEASED: {
    label: '未发布',
    type: 'info'
  }
};
var _default = exports.default = {
  name: 'MiniProgramVersionIndex',
  components: {
    MiniProgramReleaseManage: _MiniProgramReleaseManage.default,
    BatchUploadDialog: _BatchUploadDialog.default,
    BatchUploadProgress: _BatchUploadProgress.default
  },
  data: function data() {
    return {
      loading: false,
      batchLoading: false,
      batchHistoryVisible: false,
      searchForm: {
        keyword: '',
        appId: '',
        customerId: null
      },
      customerOptions: [],
      tableData: {
        list: [],
        total: 0
      },
      batchData: {
        list: [],
        total: 0
      },
      page: {
        page: 1,
        limit: 20
      },
      batchPage: {
        page: 1,
        limit: 10
      }
    };
  },
  created: function created() {
    this.loadCustomerOptions('');
    this.loadList();
  },
  methods: {
    loadList: function () {
      var _loadList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.loading = true;
              _context.p = 1;
              _context.n = 2;
              return (0, _miniProgramVersionApi.getMiniProgramAppList)(_objectSpread(_objectSpread({}, this.searchForm), this.page));
            case 2:
              this.tableData = _context.v;
            case 3:
              _context.p = 3;
              this.loading = false;
              return _context.f(3);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1,, 3, 4]]);
      }));
      function loadList() {
        return _loadList.apply(this, arguments);
      }
      return loadList;
    }(),
    loadBatchList: function () {
      var _loadBatchList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.batchLoading = true;
              _context2.p = 1;
              _context2.n = 2;
              return (0, _miniProgramVersionApi.getBatchUploadList)(this.batchPage);
            case 2:
              this.batchData = _context2.v;
            case 3:
              _context2.p = 3;
              this.batchLoading = false;
              return _context2.f(3);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1,, 3, 4]]);
      }));
      function loadBatchList() {
        return _loadBatchList.apply(this, arguments);
      }
      return loadBatchList;
    }(),
    loadCustomerOptions: function () {
      var _loadCustomerOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var query,
          data,
          _args3 = arguments,
          _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              query = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : '';
              _context3.p = 1;
              _context3.n = 2;
              return companyappApi.customersListApi({
                name: query,
                types: 3
              });
            case 2:
              data = _context3.v;
              this.customerOptions = (data || []).map(function (item) {
                return {
                  label: item.name,
                  value: item.id
                };
              });
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t = _context3.v;
              this.customerOptions = [];
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 3]]);
      }));
      function loadCustomerOptions() {
        return _loadCustomerOptions.apply(this, arguments);
      }
      return loadCustomerOptions;
    }(),
    handleCustomerVisible: function handleCustomerVisible(visible) {
      if (visible) this.loadCustomerOptions('');
    },
    handleSearch: function handleSearch() {
      this.page.page = 1;
      this.loadList();
    },
    resetSearch: function resetSearch() {
      this.searchForm = {
        keyword: '',
        appId: '',
        customerId: null
      };
      this.handleSearch();
    },
    handleSizeChange: function handleSizeChange(limit) {
      this.page.limit = limit;
      this.page.page = 1;
      this.loadList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.page.page = page;
      this.loadList();
    },
    handleBatchPageChange: function handleBatchPageChange(page) {
      this.batchPage.page = page;
      this.loadBatchList();
    },
    openReleaseManage: function openReleaseManage(row) {
      this.$refs.releaseManage.open(row);
    },
    openBatchUpload: function openBatchUpload() {
      this.$refs.batchUpload.open();
    },
    openBatchHistory: function openBatchHistory() {
      this.batchHistoryVisible = true;
      this.batchPage.page = 1;
      this.loadBatchList();
    },
    handleBatchCreated: function handleBatchCreated(batch) {
      this.loadBatchList();
      this.openBatchProgress(batch.id);
    },
    openBatchProgress: function openBatchProgress(batchId) {
      this.$refs.batchProgress.open(batchId);
    },
    getBatchStatus: function getBatchStatus(status) {
      return BATCH_STATUS[status] || {
        label: status || '-',
        type: 'info'
      };
    },
    getAuditStatus: function getAuditStatus(status) {
      return AUDIT_STATUS[status] || {
        label: status || '暂无记录',
        type: 'info'
      };
    },
    getAuthorizedPlatformNames: function getAuthorizedPlatformNames(row) {
      var names = row.authorizedPlatformNames || [];
      return names.length ? names.join('、') : '-';
    },
    getPublishStatus: function getPublishStatus(status) {
      return PUBLISH_STATUS[status] || {
        label: status || '暂无记录',
        type: 'info'
      };
    },
    getAuditTip: function getAuditTip(row) {
      return row.auditRejectReason || row.auditErrorMessage || '';
    },
    getExperienceTip: function getExperienceTip(row) {
      var description = row.experienceDescription ? "\u63CF\u8FF0\uFF1A".concat(row.experienceDescription) : '';
      var syncTime = row.experienceSyncTime ? "\u540C\u6B65\u65F6\u95F4\uFF1A".concat(this.formatDateTime(row.experienceSyncTime)) : '';
      return [description, syncTime].filter(Boolean).join('；') || "\u5F53\u524D\u4F53\u9A8C\u7248\uFF1A".concat(row.experienceVersion);
    },
    formatDateTime: function formatDateTime(value) {
      return value ? (0, _utils.parseTime)(value, '{y}-{m}-{d} {h}:{i}:{s}') : '-';
    }
  }
};